export default __webpack_public_path__ + "static/events-a9e4b8e7b4915f2b7b0542eec0131c7f.png";